/*
 *  Bootstrap Nice Select Dutch (Netherlands) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['nl-NL'] = localisation.locales['nl'] = {
    formatSearch() {
        return "Zoeken...";
    },
    formatHelpForTagging() {
        return "Voor het maken van eigen tags, focus het invoerveld en druk op 'Enter' of ',' of 'Spatiebalk' om het aan de lijst toe te voegen";
    }
}

export default localisation;